module.exports = __webpack_public_path__ + "static/media/2 (15).dbdb6230.jpg";